export default "__VITE_ASSET__b40e680e__"